class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/renew`;
    }
    /**
     * Renews the existing subscription (this request comes with empty body).
     *
     * Please note that `WebSocket` subscriptions are renewed automatically while websocket session is alive.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/subscription/{subscriptionId}/renew
     * Rate Limit Group: Light
     */
    async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
